import { defineMessages } from 'react-intl';

export default defineMessages({
    type: {
        id: 'ml.quoteandbind.pupexcludedlocatons.type',
        defaultMessage: 'Type'
    },
    address: {
        id: 'ml.quoteandbind.pupexcludedlocatons.address',
        defaultMessage: 'Address'
    },
    excluded: {
        id: 'ml.quoteandbind.pupexcludedlocatons.excluded',
        defaultMessage: 'Excluded'
    }
});
